export default {
  fontFamily: {
    ui: 'Moderat, "Helvetica Neue", Helvetica, Arial, sans-serif',
    nm: 'Work Sans',
  },
  fontSize: {
    explanation: '13px',
    heading: {
      large: '40px',
      small: '36px',
    },
    hint: '13px',
    label: {
      textArea: '14px',
      textField: '14px',
    },
    small: '13px',
    tag: '12px',
    subText: '14px',
    text: '16px',
    title: {
      large: '30px',
      normal: '24px',
      section: '20px',
    },
  },
  fontWeight: {
    bold: 700,
    light: 300,
    regular: 400,
  },
}
